export default __webpack_public_path__ + "static/media/NIE_touchpoint_10.90fee4db.mp4";